<template>
  <cdr-icon>
    <g
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect
        x="3.5"
        y="11"
        width="17"
        height="9.5"
        rx="1.5"
      />
      <rect
        x="2.5"
        y="7.5"
        width="19"
        height="3.5"
        rx="1"
      />
      <path d="M12 7.5v13" />
      <path d="M12 7.5S9.8 3 7.5 4.2 9.6 7.5 12 7.5Z" />
      <path d="M12 7.5s2.2-4.5 4.5-3.3S14.4 7.5 12 7.5Z" />
    </g>
  </cdr-icon>
</template>

<script setup lang="ts">
import { CdrIcon } from '@rei/cedar';
</script>
